<template>

	<form :action="action" method="post" id="payment-form" @submit.prevent="submit">

		<div v-if="sources.length > 0" class="form-row">
			<div class="form-group col-12" >
				<label>{{ trad.card_list }}</label>
			</div>
		</div>

		<ul class="card-list">

			<li v-for="source in sources" v-if="source.object == 'source' && source.card"
				:class="[(sourceId === source.id ? 'selected' : 'clickme'),plan_selected]"
				@click="selectSource(source.id)"
			>
				{{ source.card.brand }} -
				***-{{ source.card.last4}} -
				{{ source.card.exp_month}}/{{ source.card.exp_year}}
			</li>

			<li v-for="card in sources" v-if="card.object == 'card'"
				:class="[(sourceId === card.id ? 'selected' : 'clickme'),plan_selected]"
				@click="selectSource(card.id)"
			>
				{{ card.brand }} -
				***-{{ card.last4}} -
				{{ card.exp_month}}/{{ card.exp_year}}
			</li>

			<li
				:class="[(sourceId === 'new' ? 'selected' : ''),(sources.length === 0 ? 'd-none' : ''),plan_selected]"
				@click="selectSource('new')"
			>
				{{ trad.new_card }}
			</li>


		</ul>

		<div id="partnerfields">
			<slot></slot>
		</div>

		<RCard ref="card" :stripe-key="stripeKey" v-show="sourceId == 'new'" :trad="trad"></RCard>

		<div class="row row-btn">
			<div class="col-12">
				<button type="submit" class="btn btn-main w-100" v-if="status === 'initial'">{{ submitText }}</button>
				<button type="submit" class="btn btn-main w-100 disabled" v-if="status === 'sending'" disabled>{{ sendingText }}</button>
			</div>
		</div>

	</form>

</template>

<script>

	import axios from 'axios'
	import Alert from '../../modules/Alert'

	export default {

		props: {

			trad: {
				required: true
			},

			action: {
				required: true
			},

			plan: {
				required: true
			},

			submitText: {
				required: true
			},

			sendingText: {
				required: true
			},

			stripeKey: {
				required: true
			},

			sources: {
				default: []
			}

		},

		data() {
			return {
				isSending: false,
				status: 'initial',
				sourceId: null,
				plan_selected: null
			}
		},

		mounted() {
			if(!this.sources.length)
				this.sourceId = 'new'
			if(this.plan === 'black1M' || this.plan === 'black1M2019' || this.plan === 'black1Y' || this.plan === 'black1Y2019')
				this.plan_selected = ''
			else if(this.plan === 'gold1Y')
				this.plan_selected = 'gold'

			if(document.getElementsByClassName('clickme').length > 0)
				document.getElementsByClassName('clickme')[0].click();
		},

		methods: {

			selectSource(id) {
				this.sourceId = id
			},

			submit() {

				if(this.status !== "initial")
					return

				if(!this.sourceId) {
					Alert.error(this.trad.select_payment_method)
					return
				}

				this.status = "sending"

				if(this.sourceId !== 'new')
					return this.submitSource(this.sourceId)
						.then(this.checkResponse)
						.catch(this.checkResponseError)

				if(this.sourceId === 'new')
					return this.getCardSource()
						.then((source) => {
							this.submitSource(source)
                                .then(this.checkResponse)
                                .catch(this.checkResponseError)
						})
						.catch((err) => console.log(err))
			},

			getCardSource() {
				return this.$refs.card.getSource()
					.then((source) => {
						return source.id
					})
			},

			submitSource(source) {

			    let data = {
                    newSource: this.sourceId === 'new',
                    source
                }

			    let inputs = document.getElementById('partnerfields').querySelectorAll('input')

				inputs.forEach((input) => {
				    data[input.getAttribute('name')] = input.value
				})

				return axios.post(this.action, data)
			},

			checkResponse(res) {

				if(res.data.success)
					window.location = res.data.redirect

				if(!res.data.success)
					this.checkResponseError(res.data)
			},

			checkResponseError(err) {

				this.status = "initial"

                if(err.debug)
				    console.log(err.debug)

				if(err.message)
					Alert.error(err.message)

				if(err.validation)
				    this.handleValidationError(err.validation)
			},

            handleValidationError(errors) {
                Object.keys(errors).forEach((name) => {
			        let input = document.querySelector('input[name='+ name +']')
                    input.classList.add('is-invalid')
                    let messageElem = input.parentElement.querySelector('.invalid-feedback')
                    messageElem.querySelector('strong').innerText = errors[name][0]
                    messageElem.classList.remove('hide')
                })
			}

		}

	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/PaymentForm.vue